<template>
 
</template>

<script>
import { PartnerService } from "../../services/partnerService";
import { OnBoardingServices } from "../../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
import { RegistrationService } from "../../services/RegistrationService.js";
const RegisterService = new RegistrationService();
import Modal from "../../widgets/newModalWidget";
import loadingSpinner from "../../widgets/LoadingSpinner";
import partnerTable from "../../widgets/partner-table";
import DropDown from "../../widgets/DropDown";
import multiSelect from "vue-multi-select";
import multiSelectVue from "../../widgets/multiSelect.vue";
import widgetModal from "../../widgets/newModalWidget";
import confirmationModal from "../../widgets/confirmationModal";

export default {
  components: {
    "w-loadingSpinner": loadingSpinner,
    "w-partner-table": partnerTable,
    "w-dropdown": DropDown,
    multiSelect,
    "w-multi-select-dropdown": multiSelectVue,
    "w-modal": Modal,
    widgetModal,
    confirmationModal
  },
  data() {
    return {
      loading: false,
      partnerDetailInfo: "",
      companyCode: "",
      businessCategoryApprovedList: {
        fields: [
          {
            key: "partnerTypeABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "categoriesABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "subCategoriesABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      businessCategoryNotApprovedList: {
        fields: [
          {
            key: "documentNumberNABC",
            label: "Document Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "partnerTypeNABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "categoriesNABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "subCategoriesNABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "actionNABC",
            label: "Action",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      tempNotApprovedList: {
        fields: [
          {
            key: "documentNumberNABC",
            label: "Document Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "partnerTypeNABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "categoriesNABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "subCategoriesNABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "actionNABC",
            label: "Action",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      businessCategoryFilterText: "",
      openModal: false,
      editModal: false,
      enableSubmit: true,
      wantToSubmit: true,
      partnerList: [{ text: "Select One", value: null, disabled: true }],
      selectedPartnerType: "",
      selectedCategories: [],
      selectedSubCategories: [],
      position: "bottom",
      optionsCategory: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      optionsSubCategory: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      partnerCategory: [],
      partnerSubCategory: [],
      btnLabelPartnerCategory: values =>
        `Selected Categories (${values.length})`,
      btnLabelPartnerSubCategory: values =>
        `Selected Sub-Categories (${values.length})`,
      createdCount: 0,
      pendingCount: 0,
      rejcetedCount: 0,
      triggerModalWidget: false,
      lastResponse: "",
      modalTitle: "Partner Portal",
      alertModal: false,
      successModal: false,
      triggerConfirmModal: false,
      lastResponseConfirm: "",
      tempBCDetails: [],
      tempDocumentNumber: null,
      submitForApproval: false,
      tempListCats: [],
      tempListSubCats: [],
      increaseHeight: false
    };
  },
  watch: {},
  created() {
    this.getPartnerInfo();
    this.getPartnerApprovedBusinessCategory();
    this.getPartnerNotApprovedBusinessCategory();
  },
  computed: {},
  methods: {
    getPartnerInfo() {
      this.loading = true;
      partnerService
        .getPartnerInfo()
        .then(res => {
          if (res) {
            this.partnerDetailInfo = res.response;
            this.companyCode = res.response.currentCompanyCode;
        this.$root.isInternational =
              res.response.countryDetail.countryCode == 100 ? false : true;
            partnerService
              .getPartnertype(this.companyCode)
              .then(resp => {
                if (resp.response) {
                  resp.response.forEach((item, index) => {
                    if (item.status == "A") {
                      this.partnerList.push({
                        text: item.description,
                        value: item.partnerTypeCode
                      });
                    }
                  });
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPartnerApprovedBusinessCategory() {
      this.businessCategoryApprovedList.items = [];
      partnerService
        .getPartnerApprovedBusinessCategories()
        .then(res => {
          if (res) {
            // this.businessCategoryApprovedList.items.push(
            //   res.response.primaryBusiness
            // );
            // for (let i = 0; i < res.response.secondaryBusiness.length; i++) {
            //   this.businessCategoryApprovedList.items.push(
            //     res.response.secondaryBusiness[i]
            //   );
            // }
            for (let i = 0; i < res.response.length; i++) {
              this.businessCategoryApprovedList.items.push(
                res.response[i].businessDetails
              );
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPartnerNotApprovedBusinessCategory() {
      this.businessCategoryNotApprovedList.items = [];
      partnerService
        .getPartnerNotApprovedBusinessCategories()
        .then(res => {
          if (res) {
            this.createdCount = 0;
            this.pendingCount = 0;
            this.rejcetedCount = 0;
            this.tempNotApprovedList.items = [];
            for (let i = 0; i < res.response.length; i++) {
              this.businessCategoryNotApprovedList.items.push(res.response[i]);
              this.tempNotApprovedList.items.push(res.response[i]);
              if (res.response[i].statusCode == 7) {
                this.createdCount += 1;
              }
              if (res.response[i].statusCode == 4) {
                this.pendingCount += 1;
              }
              if (res.response[i].statusCode == 3) {
                this.rejcetedCount += 1;
              }
            }
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    emptyAllFileds() {
      this.selectedPartnerType = "";
      this.selectedCategories = [];
      this.partnerCategory = [];
      this.selectedSubCategories = [];
      this.partnerSubCategory = [];
    },
    addNewBC() {
      this.openModal = true;
      this.editModal = false;
      this.emptyAllFileds();
    },
    getSelectedPartnerType(event) {
      this.selectedPartnerType = event;
      partnerService.getPartnerCategoriesWhichCanAddMore(event).then(resp => {
        if (resp) {
          let res = resp.response;
          this.partnerCategory = [];
          this.primarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.partnerCategory.push(data);
          }
        }
      });
    },
    getPartnerCategory(event) {
      this.selectedSubCategories = [];
      this.partnerSubCategory = [];
      if (this.subCatSelectOpened != true) {
        this.increaseHeight = false;
      }
      this.catSelectOpened = false;
      if (event) {
        this.selectedCategories = event;
      }
      if (this.selectedCategories.length > 0) {
        var categoryData = [];
        this.selectedCategories.forEach(category => {
          categoryData.push(category.value);
        });
        var subCategoryData = [];
        this.selectedSubCategories.forEach(category => {
          subCategoryData.push(category.value);
        });
        partnerService
          .getPartnerSubCategoriesWhichCanAddMore(
            this.selectedPartnerType,
            categoryData,
            subCategoryData
          )
          .then(resp => {
            let res = resp.response;
            this.partnerSubCategory = [];
            for (let i = 0; i < res.length; i++) {
              let data = {};
              data.name = res[i].longDesc;
              data.value = res[i].categoryCode;
              this.partnerSubCategory.push(data);
            }
            this.loading = false;
          });
      } else {
        this.partnerSubCategory = [];
      }
    },
    getPartnerSubCategory(event) {
      if (this.catSelectOpened != true) {
        this.increaseHeight = false;
      }
      this.subCatSelectOpened = false;
      if (event) {
        this.selectedSubCategories = [];
        event.forEach(subCat => {
          this.selectedSubCategories.push(subCat);
        });
      }
    },
    checkValidation() {
      if (
        this.selectedPartnerType &&
        this.selectedCategories.length > 0 &&
        this.selectedSubCategories.length > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    saveSubmitBCDetails(event1, event2) {
      console.log("saveSubmitBCDetails");
      this.loading = true;
      var request = {
        partnerTypeCode: this.selectedPartnerType,
        documentNumber: null,
        statusCode: "",
        categories: "",
        subCategories: ""
      };
      if (event1 == true) {
        request.documentNumber = this.tempDocumentNumber;
      }
      var listCategories = [];
      this.selectedCategories.forEach(category => {
        listCategories.push(category.value);
      });
      request.categories = listCategories;
      var listSubCategories = [];
      this.selectedSubCategories.forEach(category => {
        listSubCategories.push(category.value);
      });
      request.subCategories = listSubCategories;

      if (event2 == true) {
        this.loading = false;
        request.statusCode = "C";
        console.log("r ", request);
        this.tempBCDetails = request;
        console.log("temp ", this.tempBCDetails);
        this.triggerConfirmModal = true;
        this.lastResponseConfirm = "Are you sure want to submit?";
      } else {
        request.statusCode = "N";
        partnerService
          .savePartnerAdditionalCategories(request)
          .then(res => {
            if (res) {
              if(res.status == "SUCCESS") {
              this.emptyAllFileds();
              this.loading = false;
              this.openModal = false;
              this.editModal = false;
              this.triggerModalWidget = true;
              if (event2 == true) {
                this.lastResponse =
                  "Business Category Details Submitted successfully";
              } else if (event1 == true) {
                this.lastResponse =
                  "Business Category Details Updated successfully";
              } else {
                this.lastResponse =
                  "Business Category Details Saved successfully";
              }
              this.successModal = true;
              }
              if(res.status == "FAILURE") {
              this.emptyAllFileds();
              this.loading = false;
              this.openModal = false;
              this.editModal = false;
              this.triggerModalWidget = true;
              if (event2 == true) {
                this.lastResponse =
                  res.failureMessage;
              } else if (event1 == true) {
                this.lastResponse =
                  res.failureMessage;
              } else {
                this.lastResponse =
                  res.failureMessage;
              }
              this.alertModal = true;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    clearBCDetails() {
      this.selectedPartnerType = "";
      this.selectedCategories = [];
      this.partnerCategory = [];
      this.selectedSubCategories = [];
      this.selectedSubCategories = [];
    },
    submitSavedBCDetails(event) {
      this.tempBCDetails = event;
      this.triggerConfirmModal = true;
      this.lastResponseConfirm = "Are you sure want to submit?";
    },
    submitCategoryDetails(event) {
      this.loading = true;
      var request = {
        partnerTypeCode: event.partnerTypeCode,
        documentNumber: event.documentNumber,
        statusCode: "C",
        categories: "",
        subCategories: ""
      };

      this.tempListCats = [];
      this.tempListSubCats = [];

      for (let i = 0; i < event.categories.length; i++) {
        if (event.categories[i].categoryCode == null) {
          this.tempListCats.push(event.categories[i]);
        } else {
          this.tempListCats.push(event.categories[i].categoryCode);
        }
      }
      request.categories = this.tempListCats;

      for (let i = 0; i < event.subCategories.length; i++) {
        if (event.subCategories[i].categoryCode == null) {
          this.tempListSubCats.push(event.subCategories[i]);
        } else {
          this.tempListSubCats.push(event.subCategories[i].categoryCode);
        }
      }
      request.subCategories = this.tempListSubCats;

      console.log("request ", request);
      partnerService
        .savePartnerAdditionalCategories(request)
        .then(res => {
          if (res) {
            if(res.status == "SUCCESS") {
            this.loading = false;
            this.openModal = false;
            this.triggerModalWidget = true;
            this.lastResponse =
              "Business Category Details Submitted Successfully";
            this.successModal = true;
            }
            if(res.status == "FAILURE") {
            this.loading = false;
            this.openModal = false;
            this.triggerModalWidget = true;
            this.lastResponse =
              res.failureMessage;
            this.alertModal = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    editCategoryDetails(event) {
      this.loading = true;
      this.openModal = true;
      this.editModal = true;
      this.selectedPartnerType = event.partnerTypeCode;
      this.tempDocumentNumber = event.documentNumber;

      this.getSelectedPartnerType(this.selectedPartnerType);
      this.selectedCategories = [];
      for (let i = 0; i < event.categories.length; i++) {
        let data = {};
        data.name = event.categories[i].categoryName;
        data.value = event.categories[i].categoryCode;
        this.selectedCategories.push(data);
      }

      this.selectedSubCategories = [];
      for (let i = 0; i < event.subCategories.length; i++) {
        let data = {};
        data.name = event.subCategories[i].categoryName;
        data.value = event.subCategories[i].categoryCode;
        this.selectedSubCategories.push(data);
      }
      this.getPartnerCategory(this.selectedCategories);
    },
    PBCByStatusCodes(statusCode, statusType) {
      var temp = [];
      this.tempNotApprovedList.items = [];
      for (
        let i = 0;
        i < this.businessCategoryNotApprovedList.items.length;
        i++
      ) {
        if (
          this.businessCategoryNotApprovedList.items[i].statusCode == statusCode
        ) {
          this.tempNotApprovedList.items.push(
            this.businessCategoryNotApprovedList.items[i]
          );
        }
      }
    },
    bindCategoryValue(category) {
      var selectedBussiness = [];
      if (this.partnerCategory) {
        this.partnerCategory.forEach(element => {
          category.forEach(data => {
            if (element.value == data.value) {
              selectedBussiness.push({
                name: element.name,
                value: element.value
              });
            }
          });
        });
      }
      return selectedBussiness;
    },
    bindSubCategoryValue(subCategory) {
      var selectedBussiness = [];
      if (this.partnerSubCategory) {
        this.partnerSubCategory.forEach(element => {
          subCategory.forEach(data => {
            if (element.value == data.value) {
              selectedBussiness.push({
                name: element.name,
                value: element.value
              });
            }
          });
        });
      }
      return selectedBussiness;
    },
    closeAddBCModal(event) {
      this.openModal = false;
      this.editModal = false;
    },
    changeModalSuccess() {
      this.triggerModalWidget = false;
      this.lastResponse = "";
      this.successModal = false;
      this.loading = true;
      this.getPartnerApprovedBusinessCategory();
      this.getPartnerNotApprovedBusinessCategory();
    },
    callAfterConfirmModal() {
      this.triggerConfirmModal = false;
      console.log("temp ", this.tempBCDetails);
      this.submitCategoryDetails(this.tempBCDetails, "submit-bc-details");
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    },
    submitAllForApproval() {
      this.loading = true;
      var request = [];
      for (
        let i = 0;
        i < this.businessCategoryNotApprovedList.items.length;
        i++
      ) {
        if (this.businessCategoryNotApprovedList.items[i].statusCode == 7) {
          request.push(this.businessCategoryNotApprovedList.items[i]);
        }
      }
      console.log(request);
      this.loading = false;
    },
    increaseModalHeight(event) {
      console.log("cats ", this.selectedCategories);
      console.log("sub-cats ", this.selectedSubCategories);
      if (event == "Cat") {
        this.catSelectOpened = true;
        this.subCatSelectOpened = false;
      } else {
        this.catSelectOpened = false;
        this.subCatSelectOpened = true;
      }
      this.increaseHeight = true;
    }
  }
};
</script>

<style scoped>
.orange-dot {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.add-pbc-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
  width: 130px !important;
}
.submit-pbc-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.save-pbc-btn {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 120px;
}
.save-pbc-btn:disabled {
  cursor: not-allowed;
}
.headings-multi-select {
  font-size: 12px !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
}
.action-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #939393;
}
.secondary-account-modal {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  text-align: left;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  height: 30px !important;
  vertical-align: middle;
  letter-spacing: 0.5px;
}
.secondary-close {
  position: absolute;
  right: 6px;
  top: 5px;
  background-color: white;
  border-radius: 15px;
  width: 18px;
  height: 18px;
}
.content-height-modal {
  height: 400px !important;
}
</style>
<style >
.modal-header {
  padding: 5px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-title {
  /* font-family: "Source Sans Pro", sans-serif !important; */
  font-size: 16px !important;
  font-weight: 500;
  color: #ffffff;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  padding: 8px;
  /* margin-left: 4%;
  margin-right: 5%; */
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
/* .modal-footer > .btn-primary {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  margin-right: 2%;
} */

.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.approved-gst {
  /* width: 23%; */
  /* float: left; */
  height: 18px !important;
}
.alertText {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center !important;
}
.modal-header .close {
  margin-top: 1px !important;
  padding: 0rem 0rem 0px !important;
  margin: -1rem -1rem -1rem auto;
  border: solid 1px #707070;
  /* color: rgba(0, 0, 0, 0.85); */
  font-family: "Source Sans Pro", sans-serif;
  color: red;
  border-radius: 50%;
  background-color: #ffff;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
  font-size: 17px;
  font-weight: bold;
  opacity: unset !important;
}
</style>
<style>
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.table-action {
  background-color: #6192b1;
  width: 7% !important;
}
</style>